import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { Gym } from '../interfaces/gym';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GymService {
  private static readonly DEFAULT_WHATSAPP_PHONE = '34696717678';

  private readonly gymSubject = new BehaviorSubject<Gym | null>(null);
  public gym$: Observable<Gym | null> = this.gymSubject.asObservable();

  constructor(private http: HttpClient) {}

  getCurrentGym(): Observable<Gym> {
    return this.http.get<Gym>(`${environment.apiUrl}/api/gyms/current`).pipe(
      tap(gym => {
        this.gymSubject.next(gym);
        this.applyBranding(gym);
      })
    );
  }

  getGym(): Gym | null {
    return this.gymSubject.value;
  }

  /** Listado de gimnasios activos entre los que el cliente puede cambiar. */
  getAvailableGyms(): Observable<{ id: string; name: string }[]> {
    return this.http.get<{ id: string; name: string }[]>(
      `${environment.apiUrl}/api/gyms/available`
    );
  }

  /**
   * Cambia el cliente autenticado al gimnasio indicado. El backend rechaza el
   * cambio si el cliente tiene alguna tarifa activa.
   */
  changeGym(
    clientId: string,
    gymId: string
  ): Observable<{ ok: boolean; gymId: string }> {
    return this.http.patch<{ ok: boolean; gymId: string }>(
      `${environment.apiUrl}/api/clients/${clientId}/gym`,
      { gymId }
    );
  }

  buildWhatsAppUrl(phone?: string | null): string {
    const raw = phone || GymService.DEFAULT_WHATSAPP_PHONE;
    const digits = raw.replace(/\D/g, '');
    return `https://wa.me/${digits}`;
  }

  private applyBranding(gym: Gym): void {
    // Cambiar favicon o título si es necesario
    document.title = gym.name;
  }

  setGym(gym: Gym): void {
    this.gymSubject.next(gym);
    this.applyBranding(gym);
  }
}
